interface GridInterface {
  xs: string;
  sm: string;
  md: string;
  lg: string;
  xl: string;
  xxl: string;
  '3xl': string;
  '4xl': string;
  '5xl': string;
  '6xl': string;
  '7xl': string;
  '8xl': string;
}

/**
 * Grid calculated based on font-size of 14px.
 */
const grid: GridInterface = {
  xs: '0.286rem', // 4px
  sm: '0.571rem', // 8px
  md: '1.143rem', // 16px
  lg: '1.714rem', // 24px
  xl: '2.286rem', // 32px
  xxl: '2.857rem', // 40px
  '3xl': '3.429rem', // 48px
  '4xl': '4rem', // 56px
  '5xl': '4.571rem', // 64px
  '6xl': '5.143rem', // 72px
  '7xl': '5.714rem', // 80px
  '8xl': '6.286rem', // 88px
};

export default grid;
